import Text from '@sendsprint/ui-react/dist/components/Text';
import React, { ReactNode, useState } from 'react';
import cs from 'classnames';
import { ReactComponent as CheckCircleIcon } from '@src/assets/svgs/check-circle-curve.svg';
import { ReactComponent as TimesCircleIcon } from '@src/assets/svgs/times-circle.svg';
import { ReactComponent as ClockIcon } from '@src/assets/svgs/clock.svg';
import Skeleton from '@sendsprint/ui-react/dist/components/Skeleton';

interface Props {
  variant: 'success' | 'warning' | 'error' | 'grey';
  label: string;
  tooltipContent?: ReactNode;
  onClick?: () => void;
  tooltipPosition?: 'top' | 'bottom';
  showIcon?: boolean;
  isLoading?: boolean;
  icon?: ReactNode;
  size?: 'normal' | 'small';
}

const StatusBox = ({
  variant,
  label,
  tooltipContent,
  showIcon,
  onClick,
  tooltipPosition = 'top',
  isLoading,
  icon,
  size = 'normal'
}: Props) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cs('ss-relative focus:ss-focus-ring ss-rounded-full ss-w-max', {
        'ss-bg-[#EFFEFA] ss-text-[#007A5A]': variant === 'success',
        'ss-bg-[#FEEFF0] ss-text-[#EF4444]': variant === 'error',
        'ss-bg-warning-50 ss-text-warning-500': variant === 'warning',
        'ss-bg-[#F2F4F4] ss-text-[#4D646B]': variant === 'grey',
        'ss-flex ss-items-center': showIcon,
        'ss-py-1 ss-px-3': size === 'normal',
        'ss-py-1 ss-px-2': size === 'small'
      })}>
      {isLoading && <Skeleton className="ss-w-[100px] ss-max-w-full ss-rounded" />}
      {!isLoading && (
        <>
          {isHovered && tooltipContent && (
            <Text
              className={cs(
                'ss-absolute ss-break-words ss-bg-neutral-400 ss-w-max ss-max-w-[350px] ss-px-3 ss-py-2 ss-rounded ss-text-white',
                {
                  'ss-bottom-10 ss-left-0 ss-rounded-bl-none': tooltipPosition === 'top',
                  'ss-top-10 ss-left-0 ss-rounded-tl-none': tooltipPosition === 'bottom'
                }
              )}>
              {tooltipContent}
            </Text>
          )}
          {showIcon && (
            <>
              {icon && icon}
              {!icon && (
                <>
                  {variant === 'success' && <CheckCircleIcon className="ss-inline ss-mr-1" />}
                  {variant === 'error' && <TimesCircleIcon className="ss-inline ss-mr-1" />}
                  {variant === 'grey' && <ClockIcon className="ss-inline ss-mr-1" />}
                </>
              )}
            </>
          )}
          <Text variant="paragraphSmall">{label}</Text>
        </>
      )}
    </button>
  );
};

export default StatusBox;
